import RestClient from './RestClient';
import { Message } from '../../models';

class Messages extends RestClient {
    constructor() {
        super({
            "model": Message,
            "entryPoint": "message",
            "resource": "message",
        });
    }

    preview(payload) {
        const message = JSON.parse(JSON.stringify(new this.model(payload)));

        return this.POST(`/${this.entryPoint}${this.CREATE_PATH}`, {
            message: {
                ...message,
                preview_only: true
            }
        }).then(response => response.json()).then(json => {
            if (!json.message)
                throw new Error(json?.flash?.error || 'Unable to preview recipients');

            return json.preview || null;
        });
    }
}

const MessagesApi = new Messages();

export default MessagesApi;
